/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'SENIOR_MANAGEMENT',
              'INDIVIDUALS_RESPONSIBLE_FOR_IMPLEMENTATION',
              'NEW_PRODUCTION_WORKERS',
              'EXISTING_PRODUCTION_WORKERS',
              'SECURITY_GUARDS',
              'SUBCONTRACTORS_SUPPLIERS',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    who_receives_comm_and_training_select_all_that_apply: valueSchema,
  },
}
